 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AcceptInviteView-vue":"AcceptInviteView-vue","AdminBrandsView-vue":"AdminBrandsView-vue","BrandSettingsView-vue":"BrandSettingsView-vue","BrandsView-vue":"BrandsView-vue","FormEditorView-vue":"FormEditorView-vue","FormsView-vue":"FormsView-vue","GraphicsView-vue":"GraphicsView-vue","HelpView-vue":"HelpView-vue","ImportView-vue":"ImportView-vue","InboxView-vue":"InboxView-vue","OverviewView-vue":"OverviewView-vue","PlansView-vue":"PlansView-vue","PublicFormView-vue":"PublicFormView-vue","PublicRemovalView-vue":"PublicRemovalView-vue","PublicReportView-vue":"PublicReportView-vue","PublicReviewView-vue":"PublicReviewView-vue","PublicWallView-vue":"PublicWallView-vue","PublicWithdrawView-vue":"PublicWithdrawView-vue","ReportsView-vue":"ReportsView-vue","SettingsView-vue":"SettingsView-vue","TeamView-vue":"TeamView-vue","TestimonialsView-vue":"TestimonialsView-vue","WallSettingsView-vue":"WallSettingsView-vue","WidgetEditorView-vue":"WidgetEditorView-vue","WidgetsView-vue":"WidgetsView-vue"}[chunkId]||chunkId) + "." + {"AcceptInviteView-vue":"76c79412","AdminBrandsView-vue":"96c416ec","BrandSettingsView-vue":"8bd84cb1","BrandsView-vue":"fad473b5","FormEditorView-vue":"530e82f1","FormsView-vue":"87fe2b63","GraphicsView-vue":"423ec917","HelpView-vue":"46182b69","ImportView-vue":"6b8eed9c","InboxView-vue":"7de7bf97","OverviewView-vue":"4a9b3793","PlansView-vue":"d91bc992","PublicFormView-vue":"84d9f2a5","PublicRemovalView-vue":"a89a4ccd","PublicReportView-vue":"64c766a0","PublicReviewView-vue":"cf94a6da","PublicWallView-vue":"7b8a7ed8","PublicWithdrawView-vue":"ef667f4c","ReportsView-vue":"4857748c","SettingsView-vue":"89ad1daf","TeamView-vue":"83b8442e","TestimonialsView-vue":"4c0317fa","WallSettingsView-vue":"20528343","WidgetEditorView-vue":"7fb5eba9","WidgetsView-vue":"3180d7bc","chunk-2d2084aa":"4e7dadcc","chunk-37a79d60":"473fb47e","chunk-5f202b3f":"a3cbaca6","chunk-cbaaa906":"0e070533"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AcceptInviteView-vue":1,"AdminBrandsView-vue":1,"BrandSettingsView-vue":1,"BrandsView-vue":1,"FormEditorView-vue":1,"FormsView-vue":1,"GraphicsView-vue":1,"HelpView-vue":1,"ImportView-vue":1,"InboxView-vue":1,"OverviewView-vue":1,"PlansView-vue":1,"PublicFormView-vue":1,"PublicRemovalView-vue":1,"PublicReportView-vue":1,"PublicReviewView-vue":1,"PublicWallView-vue":1,"PublicWithdrawView-vue":1,"ReportsView-vue":1,"SettingsView-vue":1,"TeamView-vue":1,"TestimonialsView-vue":1,"WallSettingsView-vue":1,"WidgetEditorView-vue":1,"WidgetsView-vue":1,"chunk-37a79d60":1,"chunk-5f202b3f":1,"chunk-cbaaa906":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AcceptInviteView-vue":"AcceptInviteView-vue","AdminBrandsView-vue":"AdminBrandsView-vue","BrandSettingsView-vue":"BrandSettingsView-vue","BrandsView-vue":"BrandsView-vue","FormEditorView-vue":"FormEditorView-vue","FormsView-vue":"FormsView-vue","GraphicsView-vue":"GraphicsView-vue","HelpView-vue":"HelpView-vue","ImportView-vue":"ImportView-vue","InboxView-vue":"InboxView-vue","OverviewView-vue":"OverviewView-vue","PlansView-vue":"PlansView-vue","PublicFormView-vue":"PublicFormView-vue","PublicRemovalView-vue":"PublicRemovalView-vue","PublicReportView-vue":"PublicReportView-vue","PublicReviewView-vue":"PublicReviewView-vue","PublicWallView-vue":"PublicWallView-vue","PublicWithdrawView-vue":"PublicWithdrawView-vue","ReportsView-vue":"ReportsView-vue","SettingsView-vue":"SettingsView-vue","TeamView-vue":"TeamView-vue","TestimonialsView-vue":"TestimonialsView-vue","WallSettingsView-vue":"WallSettingsView-vue","WidgetEditorView-vue":"WidgetEditorView-vue","WidgetsView-vue":"WidgetsView-vue"}[chunkId]||chunkId) + "." + {"AcceptInviteView-vue":"3a2eb809","AdminBrandsView-vue":"655afe5c","BrandSettingsView-vue":"b6655c2c","BrandsView-vue":"0b598306","FormEditorView-vue":"f73e014f","FormsView-vue":"20a881d6","GraphicsView-vue":"4f18f036","HelpView-vue":"7d1fee32","ImportView-vue":"9ea71e06","InboxView-vue":"eaf1c594","OverviewView-vue":"d81c1f78","PlansView-vue":"774973f3","PublicFormView-vue":"fa2dc501","PublicRemovalView-vue":"13383da2","PublicReportView-vue":"784a1391","PublicReviewView-vue":"4a53b2a4","PublicWallView-vue":"2246c7bb","PublicWithdrawView-vue":"277b7cf0","ReportsView-vue":"9da92544","SettingsView-vue":"a02dd218","TeamView-vue":"b3ed9eb7","TestimonialsView-vue":"19c7c664","WallSettingsView-vue":"10aed578","WidgetEditorView-vue":"affd5413","WidgetsView-vue":"fa5ab6d9","chunk-2d2084aa":"31d6cfe0","chunk-37a79d60":"0f8bd159","chunk-5f202b3f":"49e863fa","chunk-cbaaa906":"04fb1647"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
